import ContentLayout from "../../layout/contentLayout";
import PeopleIcon from "@mui/icons-material/People";
import Content from "./content";
/**
 * CustomerService
 *
 * صفحه مدیریت خدمات مشتریان.
 * این کامپوننت شامل:
 * - استفاده از ContentLayout برای ساختار کلی صفحه
 * - آیکون نماینده مشتریان (PeopleIcon)
 * - عنوان صفحه "خدمات مشتریان"
 * - محتوای اصلی صفحه با استفاده از کامپوننت Content
 *
 * ویژگی‌ها:
 * - isContainerFluid برای استفاده از پهنای کامل کانتینر
 *
 * @returns JSX.Element
 */
const CustomerService = () => {
  return (
    <ContentLayout icon={<PeopleIcon />} title="خدمات مشتریان" isContainerFluid>
      <Content />
    </ContentLayout>
  );
};

export default CustomerService;
